import { type BotActivity, type IUsePostMessage } from '@bingads-webui/ads-copilot-ui';
import { type ILogger } from '@bingads-webui-react/copilot-utils';
import { fakeLogger } from './utils';

export const MAX_REPLAY_COUNT_ON_AI_DEGRADE = 3;

const replayHumanMessage = (
  activity: BotActivity,
  correspondingHumanActivity: BotActivity | undefined,
  postMessage: IUsePostMessage['postMessage'],
  humanMessageReplayCountRef: React.MutableRefObject<number>,
  maxReplayCount,
  logger: ILogger = fakeLogger,
) => {
  // connect to agent if replay fails
  if (
    activity.value === 'InternalError'
    && humanMessageReplayCountRef.current >= maxReplayCount
  ) {
    logger?.trace('[Copilot - AI Degrade] Replay failed, connecting to agent');
    // eslint-disable-next-line no-param-reassign
    activity.value = 'ConnectToAgent';
  }

  // replay human message if InternalError occurs
  if (
    activity.value === 'InternalError'
    && correspondingHumanActivity?.type === 'message'
    && correspondingHumanActivity?.text
    && humanMessageReplayCountRef.current < maxReplayCount
  ) {
    // eslint-disable-next-line no-param-reassign
    humanMessageReplayCountRef.current += 1;
    logger?.trace(`[Copilot - AI Degrade] Replaying human message [${humanMessageReplayCountRef.current}/${maxReplayCount}]: ${correspondingHumanActivity.text}`);
    postMessage(
      null,
      { value: correspondingHumanActivity.text as string },
      { isHiddenFromUser: true },
    );
  }
};

const resetHumanMessageReplayCount = (
  activity: BotActivity,
  username: string,
  humanMessageReplayCountRef: React.MutableRefObject<number>,
) => {
  if (
    activity?.type === 'message' && activity.from.name === username
    && !activity.value?.isHiddenFromUser
  ) {
    // eslint-disable-next-line no-param-reassign
    humanMessageReplayCountRef.current = 0;
  }
};

export const handleInternalErrorActivities = (
  activity: BotActivity,
  existingActivities: BotActivity[],
  postMessage: IUsePostMessage['postMessage'],
  username: string,
  humanMessageReplayCountRef: React.MutableRefObject<number>,
  maxReplayCount = MAX_REPLAY_COUNT_ON_AI_DEGRADE,
  logger: ILogger = fakeLogger,
) => {
  if (humanMessageReplayCountRef.current > 0) {
    resetHumanMessageReplayCount(activity, username, humanMessageReplayCountRef);
  }
  const correspondingHumanActivity = existingActivities.find((act) => act.id === activity?.replyToId);
  if (activity.value === 'InternalError') {
    logger.trace(`[Copilot - AI Degrade] ${activity.value} activity hidden from user: ${activity.id}`);
    replayHumanMessage(
      activity,
      correspondingHumanActivity,
      postMessage,
      humanMessageReplayCountRef,
      maxReplayCount,
      logger,
    );
  }
};
